import * as ngCdkOverlay from '@angular/cdk/overlay'
import * as ngCore from '@angular/core'

import * as state from '../../../../../../../../../state'
import * as base from '../base'

/**
 * Displays information about the selected/hovered {@link state.summit.allocations.models.Outcome}
 */
@ngCore.Component({
  imports: [base.Component],
  selector: 'atn-summit-allocation-graph-outcome-overlay',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /**
   * Indicates where this overlay {@link Component} should be placed
   */
  public readonly originSg =
    ngCore.input.required<ngCdkOverlay.FlexibleConnectedPositionStrategyOrigin>(
      {
        alias: 'origin',
      },
    )

  /**
   * {@link state.summit.allocations.models.Outcome} to display in this overlay {@link Component}
   */
  public readonly outcomeSg =
    ngCore.input.required<state.summit.allocations.models.Outcome>({
      alias: 'outcome',
    })
}
